import { z } from 'zod';
/** Usage counts for a single generation type (e.g. compatibility, palm, portraits). */
export const GenerationTypeUsageDTO = z.object({
    total: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
});
/** A user's aggregated product-usage stats (messages sent + per-type generation counts). */
export const ProductUsageDTO = z.object({
    userId: z.string(),
    registeredAt: z.string().nullable(),
    messages: z.object({
        sent: z.number().int().nonnegative(),
    }),
    generations: z.object({
        compatibility: GenerationTypeUsageDTO,
        palm: GenerationTypeUsageDTO,
        portraits: GenerationTypeUsageDTO,
    }),
});
/**
 * Response for GET /api/conversations/:id/product-usage.
 * `configured` is false when the app-service product-usage API is not wired
 * (env unset) — the UI then hides the section. `usage` is null when the
 * contact has no resolved wit_user_id (or the user has no usage data).
 */
export const ProductUsageResponse = z.object({
    configured: z.boolean(),
    usage: ProductUsageDTO.nullable(),
});
//# sourceMappingURL=product-usage.js.map